import { Axios } from '@moniebook-web/utils';

import { HOST_API_URL } from '@/shared/constants';

import type { GhostSessionTokenResponse } from '../types';

export const exchangeGhostSessionToken = async (
    sessionId: string,
    accessCode: string,
): Promise<GhostSessionTokenResponse> => {
    const { data } = await Axios.get<GhostSessionTokenResponse>(
        HOST_API_URL.GHOST_SESSION_TOKEN(sessionId, accessCode),
        {
            ignoreAuthToken: true,
            exemptFromUnauthorizedError: true,
        },
    );

    return data;
};
